<script setup lang="ts">
import type { Game } from '@game/types'
import { computed, fallbackListSlug, useGameListTracking, useGameType, useGames, useI18n } from '#imports'

const props = withDefaults(defineProps<{
    pageSize?: number
    hasSidebar?: boolean
    lazy?: boolean
}>(), {
    pageSize: 16,
    hasSidebar: false,
    lazy: true,
})

const { t } = useI18n()
const { isLiveCasino } = useGameType()
const { trackingListSlug, trackingOrigin, onGameClick } = useGameListTracking('gametile', fallbackListSlug('LIVE_CASINO'))

const { data } = useGames({
    params: { page: 1, page_size: props.pageSize },
    filter: { game_types: ['CASINO'] },
    lazy: props.lazy,
    key: () => `game-list-fallback:live-casino:${props.pageSize}`,
})

// Live casino games are CASINO games with the LIVE subtype; show open tables first.
const games = computed(() =>
    (data.value?.data ?? [])
        .filter((game: Game) => isLiveCasino(game.game_type, game.game_subtype))
        .sort((a: Game, b: Game) => Number(b.opening_hours.is_open) - Number(a.opening_hours.is_open)),
)
</script>

<template>
    <div v-if="games.length" class="custom-game-section">
        <GameList
            :games="games"
            :title="t('game.gameList.LIVE_CASINO')"
            category="LIVE_CASINO"
            :tracking-list-slug="trackingListSlug"
            :tracking-origin="trackingOrigin"
            :has-sidebar="hasSidebar"
            :video-enabled="true"
            :trim-dangling-tiles="true"
            @game-click="onGameClick"
        />
    </div>
</template>
